module.exports = __webpack_public_path__ + "static/important-travel-4606f84c271dd31ede17fe1a97eeee80.jpg";